"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[310],{

/***/ 78088:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Debug$SmartcutsMacros = __webpack_require__(45083);
var cdp = Debug$SmartcutsMacros.make(false, "cdp");
var chromeEventsWebNav = Debug$SmartcutsMacros.make(false, "chrome:events:webnav");
var chromeEventsTab = Debug$SmartcutsMacros.make(false, "chrome:events:tab");
var cmdClickPlayback = Debug$SmartcutsMacros.make(false, "cmd:click:playback");
var cmdTypeRecording = Debug$SmartcutsMacros.make(false, "cmd:type:recording");
var decco = Debug$SmartcutsMacros.make(false, "decco");
var dom = Debug$SmartcutsMacros.make(false, "DOM");
var fauna = Debug$SmartcutsMacros.make(false, "fauna");
var faunaSize = Debug$SmartcutsMacros.make(false, "fauna:size");
var imageKit = Debug$SmartcutsMacros.make(false, "imageKit");
var keyLogic = Debug$SmartcutsMacros.make(false, "keyLogic");
var playback = Debug$SmartcutsMacros.make(false, "playback");
var promiseRetries = Debug$SmartcutsMacros.make(false, "promise:retries");
var promiseCancels = Debug$SmartcutsMacros.make(false, "promise:cancels");
var recording = Debug$SmartcutsMacros.make(false, "recording");
var recordingContentEditing = Debug$SmartcutsMacros.make(false, "recording:contentEditing");
var recordingEventStreaming = Debug$SmartcutsMacros.make(false, "recording:eventStreaming");
var recordingSession = Debug$SmartcutsMacros.make(false, "recording:session");
var selector = Debug$SmartcutsMacros.make(false, "selector");
var stateMachineBg = Debug$SmartcutsMacros.make(false, "stateMachine:bg");
var stateMachineBgRecording = Debug$SmartcutsMacros.make(false, "stateMachine:bg:recording");
var stateMachineBgPlayback = Debug$SmartcutsMacros.make(false, "stateMachine:bg:playback");
var stateMachineBgPlaybackCmdControl = Debug$SmartcutsMacros.make(false, "stateMachine:bg:playback:cmdControl");
var stateMachineCs = Debug$SmartcutsMacros.make(false, "stateMachine:cs");
var stateMachineCsPlayback = Debug$SmartcutsMacros.make(false, "stateMachine:cs:playback");
var stateMachineCore = Debug$SmartcutsMacros.make(false, "stateMachine:core");
var sheets = Debug$SmartcutsMacros.make(false, "sheets");
var optimizedPlayback = Debug$SmartcutsMacros.make(false, "optimizedPlayback");
var utilSpy = Debug$SmartcutsMacros.make(false, "util:spy");
var utilWaitPromise = Debug$SmartcutsMacros.make(false, "util:waitPromise");
var ux = Debug$SmartcutsMacros.make(false, "ux");
var uxAuthoringCheckbox = Debug$SmartcutsMacros.make(false, "ux:authoring:checkbox");
exports.cdp = cdp;
exports.chromeEventsWebNav = chromeEventsWebNav;
exports.chromeEventsTab = chromeEventsTab;
exports.cmdClickPlayback = cmdClickPlayback;
exports.cmdTypeRecording = cmdTypeRecording;
exports.decco = decco;
exports.dom = dom;
exports.fauna = fauna;
exports.faunaSize = faunaSize;
exports.imageKit = imageKit;
exports.keyLogic = keyLogic;
exports.playback = playback;
exports.promiseRetries = promiseRetries;
exports.promiseCancels = promiseCancels;
exports.recording = recording;
exports.recordingContentEditing = recordingContentEditing;
exports.recordingEventStreaming = recordingEventStreaming;
exports.recordingSession = recordingSession;
exports.selector = selector;
exports.stateMachineBg = stateMachineBg;
exports.stateMachineBgRecording = stateMachineBgRecording;
exports.stateMachineBgPlayback = stateMachineBgPlayback;
exports.stateMachineBgPlaybackCmdControl = stateMachineBgPlaybackCmdControl;
exports.stateMachineCs = stateMachineCs;
exports.stateMachineCsPlayback = stateMachineCsPlayback;
exports.stateMachineCore = stateMachineCore;
exports.sheets = sheets;
exports.optimizedPlayback = optimizedPlayback;
exports.utilSpy = utilSpy;
exports.utilWaitPromise = utilWaitPromise;
exports.ux = ux;
exports.uxAuthoringCheckbox = uxAuthoringCheckbox; /* cdp Not a pure module */ 


/***/ }),

/***/ 6114:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Caml = __webpack_require__(16253);
var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Belt_MapString = __webpack_require__(35082);
var Belt_SortArray = __webpack_require__(62531);
var Util$SmartcutsMacros = __webpack_require__(25092);
var ListUtils$SmartcutsMacros = __webpack_require__(57622);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
function isEmpty(xs) {
    return xs.length === 0;
}
function sort(f, xs) {
    var copyOfXs = $$Array.copy(xs);
    $$Array.sort(f, copyOfXs);
    return copyOfXs;
}
function sort2(xs, f) {
    var copyOfXs = $$Array.copy(xs);
    $$Array.sort(f, copyOfXs);
    return copyOfXs;
}
function sortByIntAttributeDescending(xs, getAttr) {
    return Belt_SortArray.stableSortBy(xs, function(val_1, val_2) {
        return Curry._1(getAttr, val_2) - Curry._1(getAttr, val_1) | 0;
    });
}
function get(index, xs) {
    return Belt_Array.get(xs, index);
}
function slice(from, to_, arr) {
    var defaultTo = to_ !== undefined ? to_ : arr.length;
    var sliceFrom = from >= 0 ? Caml.caml_int_min(from, arr.length) : Caml.caml_int_max(0, Caml.caml_int_min(arr.length, arr.length + from | 0));
    var sliceTo = defaultTo >= 0 ? Caml.caml_int_min(arr.length, defaultTo) : Caml.caml_int_max(0, Caml.caml_int_min(arr.length, arr.length + defaultTo | 0));
    if (sliceFrom >= sliceTo) {
        return [];
    } else {
        return Belt_Array.makeBy(sliceTo - sliceFrom | 0, function(i) {
            return Caml_array.get(arr, i + sliceFrom | 0);
        });
    }
}
function insertBefore(index, x, xs) {
    return $$Array.concat({
        hd: Belt_Array.slice(xs, 0, index),
        tl: {
            hd: [
                x
            ],
            tl: {
                hd: Belt_Array.sliceToEnd(xs, index),
                tl: /* [] */ 0
            }
        }
    });
}
function insertAfter(index, x, xs) {
    return $$Array.concat({
        hd: Belt_Array.slice(xs, 0, index + 1 | 0),
        tl: {
            hd: [
                x
            ],
            tl: {
                hd: Belt_Array.sliceToEnd(xs, index + 1 | 0),
                tl: /* [] */ 0
            }
        }
    });
}
function updateAt(fillWith, index, f, xs) {
    var oldX = Belt_Array.get(xs, index);
    if (oldX !== undefined) {
        return $$Array.concat({
            hd: Belt_Array.slice(xs, 0, index),
            tl: {
                hd: OptionUtils$SmartcutsMacros.withDefault([], OptionUtils$SmartcutsMacros.map(Curry._1(f, Caml_option.some(Caml_option.valFromOption(oldX))), function(newX) {
                    return [
                        newX
                    ];
                })),
                tl: {
                    hd: Belt_Array.sliceToEnd(xs, index + 1 | 0),
                    tl: /* [] */ 0
                }
            }
        });
    }
    var lastIndex = xs.length - 1 | 0;
    return $$Array.concat({
        hd: xs,
        tl: {
            hd: Caml_array.make((index - lastIndex | 0) - 1 | 0, fillWith),
            tl: {
                hd: OptionUtils$SmartcutsMacros.withDefault([], OptionUtils$SmartcutsMacros.map(Curry._1(f, undefined), function(newX) {
                    return [
                        newX
                    ];
                })),
                tl: /* [] */ 0
            }
        }
    });
}
function updateAtWithoutFill(index, f, xs) {
    var len = xs.length;
    var oldX = Belt_Array.get(xs, index);
    if (oldX !== undefined) {
        return $$Array.concat({
            hd: Belt_Array.slice(xs, 0, index),
            tl: {
                hd: OptionUtils$SmartcutsMacros.withDefault([], OptionUtils$SmartcutsMacros.map(Curry._1(f, Caml_option.some(Caml_option.valFromOption(oldX))), function(newX) {
                    return [
                        newX
                    ];
                })),
                tl: {
                    hd: Belt_Array.sliceToEnd(xs, index + 1 | 0),
                    tl: /* [] */ 0
                }
            }
        });
    } else if (index === len) {
        return $$Array.concat({
            hd: xs,
            tl: {
                hd: OptionUtils$SmartcutsMacros.withDefault([], OptionUtils$SmartcutsMacros.map(Curry._1(f, undefined), function(newX) {
                    return [
                        newX
                    ];
                })),
                tl: /* [] */ 0
            }
        });
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Can't updateAtWithoutFill an index > xs.length");
    }
}
function setWithoutFill(index, x, xs) {
    var len = xs.length;
    var _oldX = Belt_Array.get(xs, index);
    if (_oldX !== undefined) {
        return $$Array.concat({
            hd: Belt_Array.slice(xs, 0, index),
            tl: {
                hd: [
                    x
                ],
                tl: {
                    hd: (index + 1 | 0) > (len - 1 | 0) ? [] : Belt_Array.sliceToEnd(xs, index + 1 | 0),
                    tl: /* [] */ 0
                }
            }
        });
    } else if (index === len) {
        return $$Array.concat({
            hd: Belt_Array.slice(xs, 0, len),
            tl: {
                hd: [
                    x
                ],
                tl: /* [] */ 0
            }
        });
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Can't setWithoutFill an index > xs.length");
    }
}
function setWithoutFill2(xs, index, x) {
    return setWithoutFill(index, x, xs);
}
function setAtIndexAndFillGap(index, x, fill, xs) {
    var len = xs.length;
    var xs$p;
    if (index > len) {
        var fillGap = Belt_Array.make(index - len | 0, fill);
        xs$p = Belt_Array.concat(xs, fillGap);
    } else {
        xs$p = xs;
    }
    return setWithoutFill(index, x, xs$p);
}
function removeIndex(index, xs) {
    if (index === 0) {
        return Belt_Array.sliceToEnd(xs, 1);
    } else {
        return $$Array.concat({
            hd: Belt_Array.slice(xs, 0, index),
            tl: {
                hd: index >= (xs.length - 1 | 0) ? [] : Belt_Array.sliceToEnd(xs, index + 1 | 0),
                tl: /* [] */ 0
            }
        });
    }
}
function upsertBy(condition, element, xs) {
    var index = Belt_Array.getIndexBy(xs, condition);
    if (index === undefined) {
        return $$Array.append(xs, [
            element
        ]);
    }
    var param = function param(maybeEntry) {
        return OptionUtils$SmartcutsMacros.map(maybeEntry, function(param) {
            return element;
        });
    };
    return updateAtWithoutFill(index, param, xs);
}
function prependElement(xs, x) {
    return $$Array.append([
        x
    ], xs);
}
function enqueue(x, xs) {
    return $$Array.append(xs, [
        x
    ]);
}
function dequeue(xs) {
    var dequeuedElement = Belt_Array.get(xs, 0);
    if (dequeuedElement !== undefined) {
        return [
            Caml_option.valFromOption(dequeuedElement),
            slice(1, undefined, xs)
        ];
    }
}
function substituteFirstOccurrence(predicate, replaceWith, arr) {
    var index = Belt_Array.getIndexBy(arr, predicate);
    if (index === undefined) {
        return arr;
    }
    var arg = Belt_Array.get(arr, index);
    var memberToUpdate = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
    }("expected memberToUpdate in substituteFirstOccurrence");
    return Belt_Array.concatMany([
        Belt_Array.slice(arr, 0, index),
        [
            Curry._1(replaceWith, memberToUpdate)
        ],
        Belt_Array.slice(arr, index + 1 | 0, (arr.length - index | 0) - 1 | 0)
    ]);
}
function flatMapWithIndex(f, arr) {
    return Belt_Array.concatMany(Belt_Array.mapWithIndex(arr, f));
}
function flatMap(f, arr) {
    return Belt_Array.concatMany($$Array.map(f, arr));
}
function groupBy(f, xs) {
    return Belt_Array.reduce(xs, undefined, function(groupsByKey, x) {
        var key = Curry._1(f, x);
        return Belt_MapString.update(groupsByKey, key, function(maybeValue) {
            if (maybeValue !== undefined) {
                return $$Array.append(maybeValue, [
                    x
                ]);
            } else {
                return [
                    x
                ];
            }
        });
    });
}
function inGroupsOf(count, xs) {
    var lastIndex = xs.length - 1 | 0;
    return Belt_Array.reduce(xs, [
        [],
        0,
        /* [] */ 0
    ], function(param, x) {
        var index = param[1];
        var arrayOfGroups = param[0];
        var updatedGroupInReverse_1 = param[2];
        var updatedGroupInReverse = {
            hd: x,
            tl: updatedGroupInReverse_1
        };
        if (index !== lastIndex && List.length(updatedGroupInReverse) < count) {
            return [
                arrayOfGroups,
                index + 1 | 0,
                updatedGroupInReverse
            ];
        }
        var group = List.rev(updatedGroupInReverse);
        var newArrayOfGroups = Belt_Array.concat(arrayOfGroups, [
            group
        ]);
        return [
            newArrayOfGroups,
            index + 1 | 0,
            /* [] */ 0
        ];
    })[0];
}
function groupIntoPairs(xs) {
    return $$Array.map(function(group) {
        if (!group) {
            return Util$SmartcutsMacros.logAndRaiseJsError("Array doesn't have an even number of members; need to have an even number of members to group them into pairs");
        }
        var match = group.tl;
        if (match && !match.tl) {
            return [
                group.hd,
                match.hd
            ];
        } else {
            return Util$SmartcutsMacros.logAndRaiseJsError("Array doesn't have an even number of members; need to have an even number of members to group them into pairs");
        }
    }, inGroupsOf(2, xs));
}
function calcArrayIndexIfRemovedIndexes(removedIndexes, indexPriorToRemovals) {
    if (List.exists(function(i) {
        return i === indexPriorToRemovals;
    }, removedIndexes)) {
        return;
    }
    var removedIndexesPriorToTargetIndex = ListUtils$SmartcutsMacros.takeWhile(function(removedIndex) {
        return removedIndex < indexPriorToRemovals;
    }, removedIndexes);
    return indexPriorToRemovals - List.length(removedIndexesPriorToTargetIndex) | 0;
}
function replaceAtIndex(xs, index, y) {
    return $$Array.mapi(function(index$p, x) {
        if (index === index$p) {
            return y;
        } else {
            return x;
        }
    }, xs);
}
function splitAtLast(xs) {
    var lastIndex = xs.length - 1 | 0;
    return [
        Belt_Array.slice(xs, 0, lastIndex),
        Belt_Array.get(xs, lastIndex)
    ];
}
function splitAtIndex(xs, index) {
    return [
        Belt_Array.slice(xs, 0, index),
        Belt_Array.sliceToEnd(xs, index)
    ];
}
function splitAtFirstExn(msg, xs) {
    var arg = Belt_Array.get(xs, 0);
    return [
        function(param) {
            return OptionUtils$SmartcutsMacros.getExn(param, arg);
        }(msg),
        Belt_Array.sliceToEnd(xs, 1)
    ];
}
function splitAtFirst(xs) {
    return Belt_Option.map(Belt_Array.get(xs, 0), function(x0) {
        return [
            x0,
            Belt_Array.sliceToEnd(xs, 1)
        ];
    });
}
function filterMapi(f, xs) {
    return Belt_Array.reduceWithIndex(xs, [], function(out, a, i) {
        var b = Curry._2(f, i, a);
        if (b !== undefined) {
            return $$Array.append(out, [
                Caml_option.valFromOption(b)
            ]);
        } else {
            return out;
        }
    });
}
function filterMap(f, xs) {
    return filterMapi(function(param, a) {
        return Curry._1(f, a);
    }, xs);
}
function keepAsync(predicatePromise, arr) {
    return Promise.all($$Array.map(function(x) {
        return Curry._1(predicatePromise, x).then(function(shouldKeep) {
            return Promise.resolve([
                shouldKeep,
                x
            ]);
        });
    }, arr)).then(function(pairsOfShouldKeepAndElement) {
        return Promise.resolve(Belt_Array.map(Belt_Array.keep(pairsOfShouldKeepAndElement, function(param) {
            return param[0];
        }), function(prim) {
            return prim[1];
        }));
    });
}
function keepNot(f, xs) {
    return Belt_Array.keep(xs, function(x) {
        return !Curry._1(f, x);
    });
}
function unique(xs) {
    return Belt_Array.reduce(xs, [], function(uniques, x) {
        if ($$Array.mem(x, uniques)) {
            return uniques;
        } else {
            return $$Array.append(uniques, [
                x
            ]);
        }
    });
}
function shortcutWithIndexAndState(init, f, xs) {
    return Belt_Array.reduceWithIndex(xs, [
        init,
        undefined
    ], function(param, x, index) {
        var maybeResult = param[1];
        var state = param[0];
        if (maybeResult !== undefined) {
            return [
                state,
                maybeResult
            ];
        } else {
            return Curry._3(f, state, x, index);
        }
    })[1];
}
function shortcutWithState(init, f, xs) {
    return shortcutWithIndexAndState(init, function(state, x, _index) {
        return Curry._2(f, state, x);
    }, xs);
}
function shortcutWithIndex(f, xs) {
    return shortcutWithIndexAndState(undefined, function(unit, x, index) {
        return [
            unit,
            Curry._2(f, x, index)
        ];
    }, xs);
}
function shortcut(f, xs) {
    return shortcutWithIndexAndState(undefined, function(unit, x, _index) {
        return [
            unit,
            Curry._1(f, x)
        ];
    }, xs);
}
function everyWithIndex(xs, fn) {
    return Belt_Array.every(Belt_Array.mapWithIndex(xs, function(i, x) {
        return [
            i,
            x
        ];
    }), function(param) {
        return Curry._2(fn, param[0], param[1]);
    });
}
function last(xs) {
    var n = xs.length;
    if (n !== 0) {
        return Belt_Array.get(xs, n - 1 | 0);
    }
}
function firstMatch(f, lst) {
    return shortcut(function(x) {
        if (Curry._1(f, x)) {
            return Caml_option.some(x);
        }
    }, lst);
}
function firstMatchi(f, lst) {
    return shortcutWithIndex(function(x, index) {
        if (Curry._1(f, x)) {
            return [
                x,
                index
            ];
        }
    }, lst);
}
function shortcutWithIndexAndStateAsync(init, f, xs) {
    return Belt_Array.reduceWithIndex(xs, Promise.resolve([
        init,
        undefined
    ]), function(promise, x, index) {
        return promise.then(function(param) {
            if (param[1] !== undefined) {
                return promise;
            } else {
                return Curry._3(f, param[0], x, index);
            }
        });
    }).then(function(param) {
        return Promise.resolve(param[1]);
    });
}
function shortcutAsync(f, xs) {
    return shortcutWithIndexAndStateAsync(undefined, function(param, x, _index) {
        return Curry._1(f, x).then(function(y) {
            return Promise.resolve([
                undefined,
                y
            ]);
        });
    }, xs);
}
function windowMap2(f, arr) {
    var len = arr.length;
    if (len < 2) {
        return Util$SmartcutsMacros.logAndRaiseJsError("windowMap2 can only be applied to array with at least 2 elements");
    } else {
        return filterMapi(function(i, a) {
            if (i === (len - 1 | 0)) {
                return;
            } else {
                return Caml_option.some(Curry._2(f, a, Caml_array.get(arr, i + 1 | 0)));
            }
        }, arr);
    }
}
function window2ReduceWithIndex(xs, init, f) {
    return Belt_Array.reduceWithIndex(xs, init, function(result, x, index) {
        var x$p = Belt_Array.get(xs, index + 1 | 0);
        if (x$p !== undefined) {
            return Curry._4(f, result, x, Caml_option.valFromOption(x$p), index);
        } else {
            return result;
        }
    });
}
function smallest(compare, xs) {
    var match = splitAtFirstExn("Calling smallest() on empty array", xs);
    return Belt_Array.reduce(match[1], match[0], function(smallest1, x) {
        if (Curry._2(compare, smallest1, x) > 0) {
            return x;
        } else {
            return smallest1;
        }
    });
}
function takeWhile(xs, f) {
    var match = firstMatchi(function(x) {
        return !Curry._1(f, x);
    }, xs);
    if (match !== undefined) {
        return Belt_Array.slice(xs, 0, match[1]);
    } else {
        return xs;
    }
}
function collapsePairs(f, currArray) {
    var match = splitAtFirst(currArray);
    if (match !== undefined) {
        var _processedOpt;
        var _curr = match[0];
        var _remaining = match[1];
        while(true){
            var processedOpt = _processedOpt;
            var remaining = _remaining;
            var curr = _curr;
            var processed = processedOpt !== undefined ? processedOpt : [];
            var match$1 = splitAtFirst(remaining);
            if (match$1 === undefined) {
                return Belt_Array.concat(processed, [
                    curr
                ]);
            }
            var nextArray = match$1[1];
            var next = match$1[0];
            var replaceWith = Curry._3(f, curr, next, nextArray);
            if (typeof replaceWith === "number") {
                if (replaceWith === /* KeepBoth */ 0) {
                    var newProcessed = Belt_Array.concat(processed, [
                        curr
                    ]);
                    _remaining = nextArray;
                    _curr = next;
                    _processedOpt = newProcessed;
                    continue;
                }
                var match$2 = splitAtFirst(nextArray);
                if (match$2 === undefined) {
                    return processed;
                }
                var match$3 = splitAtFirst(processed);
                if (match$3 !== undefined) {
                    _remaining = nextArray;
                    _curr = match$3[0];
                    _processedOpt = match$3[1];
                    continue;
                }
                _remaining = match$2[1];
                _curr = match$2[0];
                _processedOpt = processed;
                continue;
            } else {
                switch(replaceWith.TAG | 0){
                    case /* ReplaceWith */ 0:
                        _remaining = nextArray;
                        _curr = replaceWith._0;
                        _processedOpt = processed;
                        continue;
                    case /* KeepFirstAndRemoveNumAfterFirst */ 1:
                        var nextArrayWithSubsequentRemoved = Belt_Array.sliceToEnd(nextArray, replaceWith._0 - 1 | 0);
                        var newProcessed$1 = Belt_Array.concat(processed, [
                            curr
                        ]);
                        var match$4 = splitAtFirst(nextArrayWithSubsequentRemoved);
                        if (match$4 === undefined) {
                            return newProcessed$1;
                        }
                        _remaining = match$4[1];
                        _curr = match$4[0];
                        _processedOpt = newProcessed$1;
                        continue;
                    case /* ReplaceFirstAndKeepSecond */ 2:
                        var newProcessed$2 = Belt_Array.concat(processed, [
                            replaceWith._0
                        ]);
                        _remaining = nextArray;
                        _curr = next;
                        _processedOpt = newProcessed$2;
                        continue;
                }
            }
        }
        ;
    } else {
        return [];
    }
}
function packBy(f, xs) {
    return $$Array.of_list(Belt_List.reverse(Belt_Array.reduce(xs, /* [] */ 0, function(groups, x) {
        if (!groups) {
            return {
                hd: [
                    x
                ],
                tl: groups
            };
        }
        var currentGroup = groups.hd;
        if (Curry._2(f, x, currentGroup)) {
            return {
                hd: Belt_Array.concat(currentGroup, [
                    x
                ]),
                tl: groups.tl
            };
        } else {
            return {
                hd: [
                    x
                ],
                tl: groups
            };
        }
    })));
}
function fillTo(xs, len, value) {
    if (xs.length >= len) {
        return xs;
    } else {
        return Belt_Array.concat(xs, Caml_array.make(len - xs.length | 0, value));
    }
}
function splitAtEveryOccurrences(sequence, value) {
    var len = sequence.indexOf(value, 1);
    if (len !== -1) {
        return Belt_Array.concat([
            Belt_Array.slice(sequence, 0, len)
        ], splitAtEveryOccurrences(Belt_Array.sliceToEnd(sequence, len), value));
    } else {
        return [
            sequence
        ];
    }
}
function findOneWithLowestScoreExn(xs, f, msg) {
    var match = splitAtFirstExn(msg, xs);
    var first = match[0];
    return Belt_Array.reduce(match[1], [
        first,
        Curry._1(f, first)
    ], function(param, item) {
        var lowestScore = param[1];
        var score = Curry._1(f, item);
        if (score < lowestScore) {
            return [
                item,
                score
            ];
        } else {
            return [
                param[0],
                lowestScore
            ];
        }
    })[0];
}
var mapcatWithIndex = flatMapWithIndex;
var mapcat = flatMap;
exports.isEmpty = isEmpty;
exports.sort = sort;
exports.sort2 = sort2;
exports.sortByIntAttributeDescending = sortByIntAttributeDescending;
exports.get = get;
exports.slice = slice;
exports.insertBefore = insertBefore;
exports.insertAfter = insertAfter;
exports.updateAt = updateAt;
exports.updateAtWithoutFill = updateAtWithoutFill;
exports.setWithoutFill = setWithoutFill;
exports.setWithoutFill2 = setWithoutFill2;
exports.setAtIndexAndFillGap = setAtIndexAndFillGap;
exports.removeIndex = removeIndex;
exports.upsertBy = upsertBy;
exports.prependElement = prependElement;
exports.enqueue = enqueue;
exports.dequeue = dequeue;
exports.substituteFirstOccurrence = substituteFirstOccurrence;
exports.flatMapWithIndex = flatMapWithIndex;
exports.mapcatWithIndex = mapcatWithIndex;
exports.flatMap = flatMap;
exports.mapcat = mapcat;
exports.groupBy = groupBy;
exports.inGroupsOf = inGroupsOf;
exports.groupIntoPairs = groupIntoPairs;
exports.calcArrayIndexIfRemovedIndexes = calcArrayIndexIfRemovedIndexes;
exports.replaceAtIndex = replaceAtIndex;
exports.splitAtLast = splitAtLast;
exports.splitAtIndex = splitAtIndex;
exports.splitAtFirstExn = splitAtFirstExn;
exports.splitAtFirst = splitAtFirst;
exports.filterMapi = filterMapi;
exports.filterMap = filterMap;
exports.keepAsync = keepAsync;
exports.keepNot = keepNot;
exports.unique = unique;
exports.shortcutWithIndexAndState = shortcutWithIndexAndState;
exports.shortcutWithState = shortcutWithState;
exports.shortcutWithIndex = shortcutWithIndex;
exports.shortcut = shortcut;
exports.everyWithIndex = everyWithIndex;
exports.last = last;
exports.firstMatch = firstMatch;
exports.firstMatchi = firstMatchi;
exports.shortcutWithIndexAndStateAsync = shortcutWithIndexAndStateAsync;
exports.shortcutAsync = shortcutAsync;
exports.windowMap2 = windowMap2;
exports.window2ReduceWithIndex = window2ReduceWithIndex;
exports.smallest = smallest;
exports.takeWhile = takeWhile;
exports.collapsePairs = collapsePairs;
exports.packBy = packBy;
exports.fillTo = fillTo;
exports.splitAtEveryOccurrences = splitAtEveryOccurrences;
exports.findOneWithLowestScoreExn = findOneWithLowestScoreExn; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 57622:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Caml_obj = __webpack_require__(14923);
var Belt_List = __webpack_require__(11332);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
function isEmpty(l) {
    return List.length(l) === 0;
}
function last(_l) {
    while(true){
        var l = _l;
        if (!l) {
            return;
        }
        var rest = l.tl;
        if (!rest) {
            return Caml_option.some(l.hd);
        }
        _l = rest;
        continue;
    }
    ;
}
function elemIndex(value, l) {
    var index = Belt_List.toArray(l).findIndex(function(x) {
        return Caml_obj.caml_equal(x, value);
    });
    if (index !== -1) {
        return index;
    }
}
function findIndex(f, l) {
    var _i = 0;
    var _l = l;
    while(true){
        var l$1 = _l;
        var i = _i;
        if (!l$1) {
            return;
        }
        if (Curry._1(f, l$1.hd)) {
            return i;
        }
        _l = l$1.tl;
        _i = i + 1 | 0;
        continue;
    }
    ;
}
function findWithIndex(f, l) {
    var _i = 0;
    var _l = l;
    while(true){
        var l$1 = _l;
        var i = _i;
        if (!l$1) {
            return;
        }
        var x = l$1.hd;
        if (Curry._1(f, x)) {
            return [
                x,
                i
            ];
        }
        _l = l$1.tl;
        _i = i + 1 | 0;
        continue;
    }
    ;
}
function getLast(xs) {
    var length = List.length(xs);
    if (length !== 0) {
        return Belt_List.get(xs, length - 1 | 0);
    }
}
function member(value, l) {
    return Belt_List.has(l, value, Caml_obj.caml_equal);
}
function sortBy(f, l) {
    return Belt_List.sort(l, function(a, b) {
        var a$p = Curry._1(f, a);
        var b$p = Curry._1(f, b);
        if (Caml_obj.caml_equal(a$p, b$p)) {
            return 0;
        } else if (Caml_obj.caml_lessthan(a$p, b$p)) {
            return -1;
        } else {
            return 1;
        }
    });
}
function minimum(l) {
    if (!l) {
        return;
    }
    var rest = l.tl;
    var x = l.hd;
    if (rest) {
        return Caml_option.some(Belt_List.reduce(rest, x, Caml_obj.caml_min));
    } else {
        return Caml_option.some(x);
    }
}
function drop(count, l) {
    return Belt_Option.getWithDefault(Belt_List.drop(l, count), /* [] */ 0);
}
function take(count, l) {
    return Belt_Option.getWithDefault(Belt_List.take(l, count), /* [] */ 0);
}
function splitAt(index, l) {
    return [
        take(index, l),
        drop(index, l)
    ];
}
function splitAtLast(xs) {
    var lastIndex = List.length(xs) - 1 | 0;
    var lst = Belt_List.take(xs, lastIndex);
    if (lst !== undefined) {
        return [
            lst,
            Belt_List.get(xs, lastIndex)
        ];
    } else {
        return [
            /* [] */ 0,
            Belt_List.get(xs, lastIndex)
        ];
    }
}
function updateAt(index, f, l) {
    if (index < 0) {
        return l;
    }
    var match = splitAt(index, l);
    var back = match[1];
    if (back) {
        return Belt_List.concat(match[0], {
            hd: Curry._1(f, back.hd),
            tl: back.tl
        });
    } else {
        return l;
    }
}
function updateFirstMatch(predicate, update, xs) {
    return $$Array.to_list(Belt_List.reduce(xs, [
        [],
        false
    ], function(param, x) {
        var didUpdateMatch = param[1];
        var updatedArray = param[0];
        if (!(!didUpdateMatch && Curry._1(predicate, x))) {
            return [
                $$Array.append(updatedArray, [
                    x
                ]),
                didUpdateMatch
            ];
        }
        var nextUpdatedArray = $$Array.append(updatedArray, [
            Curry._1(update, x)
        ]);
        return [
            nextUpdatedArray,
            true
        ];
    })[0]);
}
function tail(l) {
    if (l) {
        return l.tl;
    }
}
function removeAt(index, l) {
    if (index < 0) {
        return l;
    }
    var match = splitAt(index, l);
    var t = tail(match[1]);
    if (t !== undefined) {
        return Belt_List.concat(match[0], t);
    } else {
        return l;
    }
}
function remove(value, xs) {
    var index = elemIndex(value, xs);
    if (index !== undefined) {
        return removeAt(index, xs);
    } else {
        return xs;
    }
}
function upsert(value, xs) {
    var _index = elemIndex(value, xs);
    if (_index !== undefined) {
        return xs;
    } else {
        return {
            hd: value,
            tl: xs
        };
    }
}
function mapcat(f, xs) {
    return List.concat(List.map(f, xs));
}
function keepIndexes(indexes, xs) {
    return Belt_List.reduce(xs, [
        /* [] */ 0,
        0
    ], function(param, x) {
        var index = param[1];
        var newList = param[0];
        return [
            List.exists(function(i) {
                return i === index;
            }, indexes) ? {
                hd: x,
                tl: newList
            } : newList,
            index + 1 | 0
        ];
    })[0];
}
function filterMapi(f, xs) {
    return List.rev(Belt_List.reduce(xs, [
        /* [] */ 0,
        0
    ], function(param, x) {
        var i = param[1];
        var ys = param[0];
        var y = Curry._2(f, i, x);
        if (y !== undefined) {
            return [
                {
                    hd: Caml_option.valFromOption(y),
                    tl: ys
                },
                i + 1 | 0
            ];
        } else {
            return [
                ys,
                i + 1 | 0
            ];
        }
    })[0]);
}
function filterMap(f, xs) {
    return filterMapi(function(param, x) {
        return Curry._1(f, x);
    }, xs);
}
function foldLefti(init, f, xs) {
    return Belt_List.reduce(xs, [
        init,
        0
    ], function(param, currX) {
        var index = param[1];
        var nextVal = Curry._3(f, index, currX, param[0]);
        return [
            nextVal,
            index + 1 | 0
        ];
    })[0];
}
function takeWhile(f, l) {
    var _acc = /* [] */ 0;
    var _l$p = l;
    while(true){
        var l$p = _l$p;
        var acc = _acc;
        if (!l$p) {
            return Belt_List.reverse(acc);
        }
        var x = l$p.hd;
        if (!Curry._1(f, x)) {
            return Belt_List.reverse(acc);
        }
        _l$p = l$p.tl;
        _acc = {
            hd: x,
            tl: acc
        };
        continue;
    }
    ;
}
function interleave(sep, xs) {
    var lastIndex = List.length(xs) - 1 | 0;
    return foldLefti(/* [] */ 0, function(i, x, out) {
        return List.append(out, i === lastIndex ? {
            hd: x,
            tl: /* [] */ 0
        } : {
            hd: x,
            tl: {
                hd: sep,
                tl: /* [] */ 0
            }
        });
    }, xs);
}
function collapsePairs(f, currList) {
    if (currList) {
        var _processedOpt;
        var _curr = currList.hd;
        var _remaining = currList.tl;
        while(true){
            var processedOpt = _processedOpt;
            var remaining = _remaining;
            var curr = _curr;
            var processed = processedOpt !== undefined ? processedOpt : /* [] */ 0;
            if (!remaining) {
                return List.rev({
                    hd: curr,
                    tl: processed
                });
            }
            var nextList = remaining.tl;
            var next = remaining.hd;
            var replaceWith = Curry._3(f, curr, next, nextList);
            if (typeof replaceWith === "number") {
                if (replaceWith === /* KeepBoth */ 0) {
                    _remaining = nextList;
                    _curr = next;
                    _processedOpt = {
                        hd: curr,
                        tl: processed
                    };
                    continue;
                }
                if (!nextList) {
                    return List.rev(processed);
                }
                if (processed) {
                    _remaining = nextList;
                    _curr = processed.hd;
                    _processedOpt = processed.tl;
                    continue;
                }
                _remaining = nextList.tl;
                _curr = nextList.hd;
                _processedOpt = processed;
                continue;
            } else {
                switch(replaceWith.TAG | 0){
                    case /* ReplaceWith */ 0:
                        _remaining = nextList;
                        _curr = replaceWith._0;
                        _processedOpt = processed;
                        continue;
                    case /* KeepFirstAndRemoveNumAfterFirst */ 1:
                        var nextListWithSubsequentRemoved = OptionUtils$SmartcutsMacros.withDefault(/* [] */ 0, Belt_List.drop(nextList, replaceWith._0 - 1 | 0));
                        var newProcessed = {
                            hd: curr,
                            tl: processed
                        };
                        if (!nextListWithSubsequentRemoved) {
                            return List.rev(newProcessed);
                        }
                        _remaining = nextListWithSubsequentRemoved.tl;
                        _curr = nextListWithSubsequentRemoved.hd;
                        _processedOpt = newProcessed;
                        continue;
                    case /* ReplaceFirstAndKeepSecond */ 2:
                        _remaining = nextList;
                        _curr = next;
                        _processedOpt = {
                            hd: replaceWith._0,
                            tl: processed
                        };
                        continue;
                }
            }
        }
        ;
    } else {
        return /* [] */ 0;
    }
}
function collapseTriplets(f, currList) {
    if (!currList) {
        return currList;
    }
    var match = currList.tl;
    if (!match) {
        return currList;
    }
    var match$1 = match.tl;
    if (match$1) {
        var _processedOpt;
        var _first = currList.hd;
        var _second = match.hd;
        var _third = match$1.hd;
        var _remaining = match$1.tl;
        while(true){
            var processedOpt = _processedOpt;
            var remaining = _remaining;
            var third = _third;
            var second = _second;
            var first = _first;
            var processed = processedOpt !== undefined ? processedOpt : /* [] */ 0;
            var match$2 = Curry._4(f, first, second, third, remaining);
            var nextFirst;
            var nextSecond;
            var nextThird;
            var nextRemaining;
            if (typeof match$2 === "number") {
                if (match$2 !== 0) {
                    if (!remaining) {
                        return List.rev(processed);
                    }
                    var match$3 = remaining.tl;
                    if (!match$3) {
                        return List.append(List.rev(processed), remaining);
                    }
                    var match$4 = match$3.tl;
                    if (!match$4) {
                        return List.append(List.rev(processed), remaining);
                    }
                    nextFirst = remaining.hd;
                    nextSecond = match$3.hd;
                    nextThird = match$4.hd;
                    nextRemaining = match$4.tl;
                } else {
                    if (!remaining) {
                        return List.rev({
                            hd: third,
                            tl: {
                                hd: second,
                                tl: {
                                    hd: first,
                                    tl: processed
                                }
                            }
                        });
                    }
                    _remaining = remaining.tl;
                    _third = remaining.hd;
                    _second = third;
                    _first = second;
                    _processedOpt = {
                        hd: first,
                        tl: processed
                    };
                    continue;
                }
            } else {
                var match$5 = match$2._0;
                if (match$5) {
                    var match$6 = match$5.tl;
                    var nextFirst$1 = match$5.hd;
                    if (match$6) {
                        var match$7 = match$6.tl;
                        var nextSecond$1 = match$6.hd;
                        if (match$7) {
                            _remaining = List.append(match$7.tl, remaining);
                            _third = match$7.hd;
                            _second = nextSecond$1;
                            _first = nextFirst$1;
                            _processedOpt = processed;
                            continue;
                        }
                        if (!remaining) {
                            return List.append(List.rev(processed), {
                                hd: nextFirst$1,
                                tl: {
                                    hd: nextSecond$1,
                                    tl: /* [] */ 0
                                }
                            });
                        }
                        _remaining = remaining.tl;
                        _third = remaining.hd;
                        _second = nextSecond$1;
                        _first = nextFirst$1;
                        _processedOpt = processed;
                        continue;
                    }
                    if (!remaining) {
                        return List.append(List.rev(processed), {
                            hd: nextFirst$1,
                            tl: remaining
                        });
                    }
                    var match$8 = remaining.tl;
                    if (!match$8) {
                        return List.append(List.rev(processed), {
                            hd: nextFirst$1,
                            tl: remaining
                        });
                    }
                    _remaining = match$8.tl;
                    _third = match$8.hd;
                    _second = remaining.hd;
                    _first = nextFirst$1;
                    _processedOpt = processed;
                    continue;
                }
                if (!remaining) {
                    return List.rev(processed);
                }
                var match$9 = remaining.tl;
                if (!match$9) {
                    return List.append(List.rev(processed), remaining);
                }
                var match$10 = match$9.tl;
                if (!match$10) {
                    return List.append(List.rev(processed), remaining);
                }
                nextFirst = remaining.hd;
                nextSecond = match$9.hd;
                nextThird = match$10.hd;
                nextRemaining = match$10.tl;
            }
            _remaining = nextRemaining;
            _third = nextThird;
            _second = nextSecond;
            _first = nextFirst;
            _processedOpt = processed;
            continue;
        }
        ;
    } else {
        return currList;
    }
}
function shortcutWithIndexAndState(init, f, lst) {
    return Belt_List.reduceWithIndex(lst, [
        init,
        undefined
    ], function(param, x, index) {
        var maybeResult = param[1];
        var state = param[0];
        if (maybeResult !== undefined) {
            return [
                state,
                maybeResult
            ];
        } else {
            return Curry._3(f, state, x, index);
        }
    })[1];
}
function shortcutWithState(init, f, lst) {
    return shortcutWithIndexAndState(init, function(state, x, _index) {
        return Curry._2(f, state, x);
    }, lst);
}
function shortcutWithIndex(f, lst) {
    return shortcutWithIndexAndState(undefined, function(unit, x, index) {
        return [
            unit,
            Curry._2(f, x, index)
        ];
    }, lst);
}
function shortcut(f, lst) {
    return shortcutWithIndexAndState(undefined, function(unit, x, _index) {
        return [
            unit,
            Curry._1(f, x)
        ];
    }, lst);
}
function removeValue(value, l) {
    var index = findIndex(function(x) {
        return Caml_obj.caml_equal(x, value);
    }, l);
    if (index !== undefined) {
        return removeAt(index, l);
    } else {
        return l;
    }
}
function removeValues(values, l) {
    return Belt_List.keep(l, function(x) {
        return !List.exists(function(value) {
            return Caml_obj.caml_equal(value, x);
        }, values);
    });
}
function firstMatch(f, lst) {
    return shortcut(function(x) {
        if (Curry._1(f, x)) {
            return Caml_option.some(x);
        }
    }, lst);
}
function unique(xs) {
    return Belt_List.reduce(xs, /* [] */ 0, function(uniques, x) {
        if (List.mem(x, uniques)) {
            return uniques;
        } else {
            return List.append(uniques, {
                hd: x,
                tl: /* [] */ 0
            });
        }
    });
}
function mapWithState(init, f, xs) {
    return Belt_List.reduce(xs, [
        /* [] */ 0,
        init
    ], function(param, x) {
        var match = Curry._2(f, param[1], x);
        return [
            Belt_List.concat(param[0], {
                hd: match[1],
                tl: /* [] */ 0
            }),
            match[0]
        ];
    })[0];
}
var prepend = Belt_List.add;
exports.isEmpty = isEmpty;
exports.last = last;
exports.elemIndex = elemIndex;
exports.findIndex = findIndex;
exports.findWithIndex = findWithIndex;
exports.getLast = getLast;
exports.member = member;
exports.sortBy = sortBy;
exports.minimum = minimum;
exports.drop = drop;
exports.take = take;
exports.splitAt = splitAt;
exports.prepend = prepend;
exports.splitAtLast = splitAtLast;
exports.updateAt = updateAt;
exports.updateFirstMatch = updateFirstMatch;
exports.tail = tail;
exports.removeAt = removeAt;
exports.remove = remove;
exports.upsert = upsert;
exports.mapcat = mapcat;
exports.keepIndexes = keepIndexes;
exports.filterMapi = filterMapi;
exports.filterMap = filterMap;
exports.foldLefti = foldLefti;
exports.takeWhile = takeWhile;
exports.interleave = interleave;
exports.collapsePairs = collapsePairs;
exports.collapseTriplets = collapseTriplets;
exports.shortcutWithIndexAndState = shortcutWithIndexAndState;
exports.shortcutWithState = shortcutWithState;
exports.shortcutWithIndex = shortcutWithIndex;
exports.shortcut = shortcut;
exports.removeValue = removeValue;
exports.removeValues = removeValues;
exports.firstMatch = firstMatch;
exports.unique = unique;
exports.mapWithState = mapWithState; /* No side effect */ 


/***/ }),

/***/ 18726:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Caml_option = __webpack_require__(57175);
function $$return(v) {
    return Caml_option.some(v);
}
function wrap(fn, opt) {
    if (opt !== undefined) {
        return Caml_option.some(Curry._1(fn, Caml_option.valFromOption(opt)));
    }
}
function $great$great$eq(opt, fn) {
    if (opt !== undefined) {
        return Curry._1(fn, Caml_option.valFromOption(opt));
    }
}
function $neg$question$great(opt, fn) {
    if (opt !== undefined) {
        return Caml_option.some(Curry._1(fn, Caml_option.valFromOption(opt)));
    }
}
exports.$$return = $$return;
exports.wrap = wrap;
exports.$great$great$eq = $great$great$eq;
exports.$neg$question$great = $neg$question$great; /* No side effect */ 


/***/ }),

/***/ 9324:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Caml_obj = __webpack_require__(14923);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Caml_option = __webpack_require__(57175);
var Caml_exceptions = __webpack_require__(96181);
var OptionMonad$SmartcutsMacros = __webpack_require__(18726);
function makeSome(x) {
    return Caml_option.some(x);
}
function bool_of_option(opt) {
    return opt !== undefined;
}
function set_default($$default, opt) {
    if (opt !== undefined) {
        return Caml_option.valFromOption(opt);
    } else {
        return $$default;
    }
}
function option_of_array(l) {
    if (l.length !== 0) {
        return Caml_option.some(Caml_array.get(l, 0));
    }
}
function option_of_list(l) {
    if (List.length(l) > 0) {
        return Caml_option.some(List.hd(l));
    }
}
function unbundleTuple(tuple) {
    if (tuple !== undefined) {
        return [
            Caml_option.some(tuple[0]),
            Caml_option.some(tuple[1])
        ];
    } else {
        return [
            undefined,
            undefined
        ];
    }
}
var UnExpectedNone = /* @__PURE__ */ Caml_exceptions.create("OptionUtils-SmartcutsMacros.UnExpectedNone");
function extract_option_exn(opt) {
    if (opt !== undefined) {
        return Caml_option.valFromOption(opt);
    }
    throw {
        RE_EXN_ID: UnExpectedNone,
        Error: new Error()
    };
}
function set_array_default($$default, arr) {
    if (arr.length === 0) {
        return $$default;
    } else {
        return arr;
    }
}
function getExn(msg, x) {
    if (x !== undefined) {
        return Caml_option.valFromOption(x);
    }
    throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "option is None; " + msg,
        Error: new Error()
    };
}
function $neg$bang$great(x, fn) {
    if (x !== undefined) {
        return Curry._1(fn, Caml_option.valFromOption(x));
    }
}
function withDefault($$default, x) {
    if (x !== undefined) {
        return Caml_option.valFromOption(x);
    } else {
        return $$default;
    }
}
function andThen(f, opt) {
    if (opt !== undefined) {
        return Curry._1(f, Caml_option.valFromOption(opt));
    }
}
function orElse(backupValue, value) {
    if (value !== undefined) {
        return Caml_option.some(Caml_option.valFromOption(value));
    } else {
        return backupValue;
    }
}
function orElseWithFn(fn, value) {
    if (value !== undefined) {
        return Caml_option.some(Caml_option.valFromOption(value));
    } else {
        return Curry._1(fn, undefined);
    }
}
function equalsValueIfUnwrapped(value, x) {
    if (x !== undefined) {
        return Caml_obj.caml_equal(value, Caml_option.valFromOption(x));
    } else {
        return false;
    }
}
function equalsSome(value, x) {
    if (x !== undefined) {
        return Caml_obj.caml_equal(value, Caml_option.valFromOption(x));
    } else {
        return false;
    }
}
function arrayOfOptionsToArrayOfUnboxedSomes(xs) {
    return Belt_Array.reduce(xs, [], function(output, maybeX) {
        if (maybeX !== undefined) {
            return $$Array.append(output, [
                Caml_option.valFromOption(maybeX)
            ]);
        } else {
            return output;
        }
    });
}
function listOfOptionsToListOfUnboxedSomes(xs) {
    return List.rev(Belt_List.reduce(xs, /* [] */ 0, function(output, maybeX) {
        if (maybeX !== undefined) {
            return {
                hd: Caml_option.valFromOption(maybeX),
                tl: output
            };
        } else {
            return output;
        }
    }));
}
function toList(x) {
    if (x !== undefined) {
        return {
            hd: Caml_option.valFromOption(x),
            tl: /* [] */ 0
        };
    } else {
        return /* [] */ 0;
    }
}
function toArray(x) {
    if (x !== undefined) {
        return [
            Caml_option.valFromOption(x)
        ];
    } else {
        return [];
    }
}
function optionalString(s) {
    if (s.trim() === "") {
        return;
    } else {
        return s;
    }
}
function stringify(stringify$1, maybeValue) {
    if (maybeValue !== undefined) {
        return "Some(" + (Curry._1(stringify$1, Caml_option.valFromOption(maybeValue)) + ")");
    } else {
        return "None";
    }
}
function keepAsync(predicatePromise, maybe) {
    if (maybe === undefined) {
        return Promise.resolve(undefined);
    }
    var x = Caml_option.valFromOption(maybe);
    return Curry._1(predicatePromise, x).then(function(result) {
        return Promise.resolve(result ? Caml_option.some(x) : undefined);
    });
}
var $$return = OptionMonad$SmartcutsMacros.$$return;
var wrap = OptionMonad$SmartcutsMacros.wrap;
var $great$great$eq = OptionMonad$SmartcutsMacros.$great$great$eq;
var $neg$question$great = OptionMonad$SmartcutsMacros.$neg$question$great;
var map = OptionMonad$SmartcutsMacros.$neg$question$great;
exports.$$return = $$return;
exports.wrap = wrap;
exports.$great$great$eq = $great$great$eq;
exports.$neg$question$great = $neg$question$great;
exports.makeSome = makeSome;
exports.bool_of_option = bool_of_option;
exports.set_default = set_default;
exports.option_of_array = option_of_array;
exports.option_of_list = option_of_list;
exports.unbundleTuple = unbundleTuple;
exports.UnExpectedNone = UnExpectedNone;
exports.extract_option_exn = extract_option_exn;
exports.set_array_default = set_array_default;
exports.getExn = getExn;
exports.map = map;
exports.$neg$bang$great = $neg$bang$great;
exports.withDefault = withDefault;
exports.andThen = andThen;
exports.orElse = orElse;
exports.orElseWithFn = orElseWithFn;
exports.equalsValueIfUnwrapped = equalsValueIfUnwrapped;
exports.equalsSome = equalsSome;
exports.arrayOfOptionsToArrayOfUnboxedSomes = arrayOfOptionsToArrayOfUnboxedSomes;
exports.listOfOptionsToListOfUnboxedSomes = listOfOptionsToListOfUnboxedSomes;
exports.toList = toList;
exports.toArray = toArray;
exports.optionalString = optionalString;
exports.stringify = stringify;
exports.keepAsync = keepAsync; /* No side effect */ 


/***/ }),

/***/ 80310:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Caml_option = __webpack_require__(57175);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
function s(prim) {
    return prim;
}
function n(prim) {
    return prim;
}
function inject(_cls, _fn) {
    return _cls.getInitialProps = _fn;
}
function joinWith(xs, v) {
    var _xs = xs;
    var _ys = [];
    while(true){
        var ys = _ys;
        var xs$1 = _xs;
        var match = ArrayUtils$SmartcutsMacros.splitAtLast(xs$1);
        var y = match[1];
        if (y === undefined) {
            return ys;
        }
        var y$1 = Caml_option.valFromOption(y);
        var match$1 = ys.length;
        var ys$p = match$1 !== 0 ? $$Array.append([
            y$1,
            v
        ], ys) : [
            y$1
        ];
        _ys = ys$p;
        _xs = match[0];
        continue;
    }
    ;
}
function joinWith_(v, xs) {
    return joinWith(xs, v);
}
exports.s = s;
exports.n = n;
exports.inject = inject;
exports.joinWith = joinWith;
exports.joinWith_ = joinWith_; /* ArrayUtils-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 25092:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_exn = __webpack_require__(82900);
var Js_json = __webpack_require__(85688);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Caml_option = __webpack_require__(57175);
var Caml_exceptions = __webpack_require__(96181);
var Caml_js_exceptions = __webpack_require__(74518);
var Log$SmartcutsMacros = __webpack_require__(78088);
function promiseWithIndex(fn, xs) {
    return Belt_Array.reduceWithIndex(xs, Promise.resolve(undefined), function(promise1, x, index) {
        return promise1.then(function(result) {
            if (result !== undefined) {
                return Promise.resolve(result);
            } else {
                return Curry._2(fn, x, index);
            }
        });
    });
}
function promise(fn, xs) {
    return promiseWithIndex(function(x, _index) {
        return Curry._1(fn, x);
    }, xs);
}
var Shortcut = {
    promiseWithIndex: promiseWithIndex,
    promise: promise
};
var Invalid_argument = /* @__PURE__ */ Caml_exceptions.create("Util-SmartcutsMacros.Invalid_argument");
function noop_0(param) {}
function noop_1(param) {}
function spyTransform(msg, transform, x) {
    Curry._2(Log$SmartcutsMacros.utilSpy.log2, msg, Curry._1(transform, x));
    return x;
}
function spyPromise1(msg, promise2) {
    return promise2.then(function(x) {
        Curry._2(Log$SmartcutsMacros.utilSpy.log2, msg, x);
        return Promise.resolve(x);
    });
}
function shortcut(fn, xs) {
    return $$Array.fold_left(function(result, x) {
        if (result !== undefined) {
            return result;
        } else {
            return Curry._1(fn, x);
        }
    }, undefined, xs);
}
function shortcut2(xs, fn) {
    return shortcut(fn, xs);
}
function shortcutWithIndex(fn, xs) {
    return Belt_Array.reduceWithIndex(xs, undefined, function(result, x, index) {
        if (result !== undefined) {
            return result;
        } else {
            return Curry._2(fn, x, index);
        }
    });
}
function shortcutWithIndex2(xs, fn) {
    return shortcutWithIndex(fn, xs);
}
function shortcutPromise(fn, xs) {
    return $$Array.fold_left(function(promise3, x) {
        return promise3.then(function(result) {
            if (result !== undefined) {
                return Promise.resolve(result);
            } else {
                return Curry._1(fn, x);
            }
        });
    }, Promise.resolve(undefined), xs);
}
function shortcutList(fn, xs) {
    return List.fold_left(function(result, x) {
        if (result !== undefined) {
            return result;
        } else {
            return Curry._1(fn, x);
        }
    }, undefined, xs);
}
function shortcutListWithIndex(fn, xs) {
    return Belt_List.reduceWithIndex(xs, undefined, function(result, x, index) {
        if (result !== undefined) {
            return result;
        } else {
            return Curry._2(fn, x, index);
        }
    });
}
function logAndRaiseJsError(message) {
    try {
        return Js_exn.raiseError(message);
    } catch (raw_exn) {
        var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
        if (exn.RE_EXN_ID === Js_exn.$$Error) {
            console.error(exn._1);
            throw exn;
        }
        throw exn;
    }
}
function compose(f, g, a) {
    return Curry._1(f, Curry._1(g, a));
}
function not_(x) {
    return !x;
}
function stringify(stringifyOk, stringifyError, result) {
    if (result.TAG === /* Ok */ 0) {
        return "Ok(" + (Curry._1(stringifyOk, result._0) + ")");
    } else {
        return "Error(" + (Curry._1(stringifyError, result._0) + ")");
    }
}
var Result = {
    stringify: stringify
};
function t_encode(id) {
    return id;
}
function t_decode(encoded) {
    var num = Js_json.decodeNumber(encoded);
    if (num !== undefined) {
        return {
            TAG: /* Ok */ 0,
            _0: num | 0
        };
    } else {
        return Decco.error(undefined, "Expected json number", encoded);
    }
}
var GlobalTimeoutId = {
    t_encode: t_encode,
    t_decode: t_decode
};
function t_encode$1(id) {
    return id;
}
function t_decode$1(encoded) {
    var num = Js_json.decodeNumber(encoded);
    if (num !== undefined) {
        return {
            TAG: /* Ok */ 0,
            _0: num | 0
        };
    } else {
        return Decco.error(undefined, "Expected json number", encoded);
    }
}
var GlobalIntervalId = {
    t_encode: t_encode$1,
    t_decode: t_decode$1
};
var TimedOut = /* @__PURE__ */ Caml_exceptions.create("Util-SmartcutsMacros.WaitFor.TimedOut");
var PredicateTimedOut = /* @__PURE__ */ Caml_exceptions.create("Util-SmartcutsMacros.WaitFor.PredicateTimedOut");
var PredicateError = /* @__PURE__ */ Caml_exceptions.create("Util-SmartcutsMacros.WaitFor.PredicateError");
var WaitFor = {
    TimedOut: TimedOut,
    PredicateTimedOut: PredicateTimedOut,
    PredicateError: PredicateError,
    checkIntervalMs: 500,
    defaultTimeout: 15000.0
};
function wait(millis) {
    return new Promise(function(resolve, param) {
        var timeoutId = {
            contents: 0
        };
        timeoutId.contents = setTimeout(function(param) {
            return resolve(timeoutId.contents);
        }, millis);
    });
}
function waitFloat(millis) {
    return new Promise(function(resolve, param) {
        var timeoutId = {
            contents: 0
        };
        timeoutId.contents = setTimeout(function(param) {
            return resolve(timeoutId.contents);
        }, millis);
    });
}
function timedOutError(defaultExn, maybeRaiseExn) {
    if (maybeRaiseExn !== undefined) {
        return Curry._1(maybeRaiseExn, undefined);
    } else {
        return defaultExn;
    }
}
function waitForPromise(timeoutOpt, intervalOpt, predicate, maybeRaiseExn, param) {
    var timeout = timeoutOpt !== undefined ? timeoutOpt : 15000.0;
    var interval = intervalOpt !== undefined ? intervalOpt : 500;
    var predicateDidTimeout = {
        contents: false
    };
    var onPredicateTimedOutCallbacks = {
        contents: []
    };
    var addOnPredicateTimedOutCallback = function addOnPredicateTimedOutCallback(callback) {
        if (predicateDidTimeout.contents) {
            return Curry._1(callback, undefined);
        } else {
            onPredicateTimedOutCallbacks.contents = $$Array.append(onPredicateTimedOutCallbacks.contents, [
                callback
            ]);
            return;
        }
    };
    var onPredicateTimedOut = function onPredicateTimedOut(param) {
        return Belt_Array.forEach(onPredicateTimedOutCallbacks.contents, function(callback) {
            return Curry._1(callback, undefined);
        });
    };
    return new Promise(function(resolve, reject) {
        var epoch = Date.now();
        var loop = function(param) {
            var millisElapsed = Date.now() - epoch;
            Curry._1(Log$SmartcutsMacros.utilWaitPromise.log1, "WAITED FOR " + (millisElapsed.toString() + (" milliseconds relative to timeout " + (timeout.toString() + (" milliseconds (remaining timeout = " + ((timeout - millisElapsed).toString() + " milliseconds)"))))));
            if (millisElapsed > timeout) {
                return reject(timedOutError({
                    RE_EXN_ID: TimedOut,
                    _1: timeout
                }, maybeRaiseExn));
            }
            var predicateDidResolve = {
                contents: false
            };
            var predicateTimeoutId = setTimeout(function(param) {
                if (predicateDidResolve.contents) {
                    return;
                } else {
                    predicateDidTimeout.contents = true;
                    onPredicateTimedOut(undefined);
                    return reject(timedOutError({
                        RE_EXN_ID: PredicateTimedOut,
                        _1: timeout
                    }, maybeRaiseExn));
                }
            }, timeout - millisElapsed);
            Curry._1(predicate, addOnPredicateTimedOutCallback).then(function(result) {
                predicateDidResolve.contents = true;
                if (predicateDidTimeout.contents) {
                    return Promise.resolve(undefined);
                } else {
                    clearTimeout(predicateTimeoutId);
                    if (result !== undefined) {
                        resolve(Caml_option.valFromOption(result));
                        return Promise.resolve(undefined);
                    } else {
                        return wait(interval).then(function(param) {
                            loop(undefined);
                            return Promise.resolve(undefined);
                        });
                    }
                }
            }).catch(function(error) {
                reject({
                    RE_EXN_ID: PredicateError,
                    _1: error
                });
                return Promise.resolve(undefined);
            });
        };
        return loop(undefined);
    });
}
function waitFor(timeout, interval, predicate, raiseExn, param) {
    var promisePredicate = function promisePredicate(param) {
        return Promise.resolve(Curry._1(predicate, undefined));
    };
    return waitForPromise(timeout, interval, promisePredicate, raiseExn, undefined);
}
var WaitFor2 = {};
function waitForPromise2(timeoutOpt, intervalOpt, predicate) {
    var timeout = timeoutOpt !== undefined ? timeoutOpt : 15000.0;
    var interval = intervalOpt !== undefined ? intervalOpt : 500;
    var predicateDidTimeout = {
        contents: false
    };
    var onPredicateTimedOutCallbacks = {
        contents: []
    };
    var addOnPredicateTimedOutCallback = function addOnPredicateTimedOutCallback(callback) {
        if (predicateDidTimeout.contents) {
            return Curry._1(callback, undefined);
        } else {
            onPredicateTimedOutCallbacks.contents = $$Array.append(onPredicateTimedOutCallbacks.contents, [
                callback
            ]);
            return;
        }
    };
    var onPredicateTimedOut = function onPredicateTimedOut(param) {
        return Belt_Array.forEach(onPredicateTimedOutCallbacks.contents, function(callback) {
            return Curry._1(callback, undefined);
        });
    };
    return new Promise(function(resolve, param) {
        var epoch = Date.now();
        var loop = function(maybeExtraInfo) {
            var millisElapsed = Date.now() - epoch;
            Curry._1(Log$SmartcutsMacros.utilWaitPromise.log1, "WAITED FOR " + (millisElapsed.toString() + (" milliseconds relative to timeout " + (timeout.toString() + (" milliseconds (remaining timeout = " + ((timeout - millisElapsed).toString() + " milliseconds)"))))));
            if (millisElapsed > timeout) {
                return resolve({
                    TAG: /* Ok */ 0,
                    _0: {
                        TAG: /* TimedOut */ 1,
                        _0: timeout,
                        _1: maybeExtraInfo
                    }
                });
            }
            var predicateDidResolve = {
                contents: false
            };
            var predicateTimeoutId = setTimeout(function(param) {
                if (predicateDidResolve.contents) {
                    return;
                } else {
                    predicateDidTimeout.contents = true;
                    onPredicateTimedOut(undefined);
                    return resolve({
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* PredicateTimedOut */ 2,
                            _0: timeout,
                            _1: maybeExtraInfo
                        }
                    });
                }
            }, timeout - millisElapsed);
            var exit = 0;
            var predicatePromiseReturned;
            try {
                predicatePromiseReturned = Curry._1(predicate, addOnPredicateTimedOutCallback);
                exit = 1;
            } catch (raw_e) {
                var e = Caml_js_exceptions.internalToOCamlException(raw_e);
                Promise.resolve(resolve({
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* UncaughtPredicateError */ 0,
                        _0: e
                    }
                }));
            }
            if (exit === 1) {
                predicatePromiseReturned.then(function(predicateOutcome) {
                    predicateDidResolve.contents = true;
                    if (predicateDidTimeout.contents) {
                        return Promise.resolve(undefined);
                    }
                    clearTimeout(predicateTimeoutId);
                    if (typeof predicateOutcome === "number") {
                        return wait(interval).then(function(param) {
                            loop(undefined);
                            return Promise.resolve(undefined);
                        });
                    }
                    switch(predicateOutcome.TAG | 0){
                        case /* PredicateSatisfied */ 0:
                            resolve({
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* PredicateDidResolveTo */ 0,
                                    _0: predicateOutcome._0
                                }
                            });
                            return Promise.resolve(undefined);
                        case /* PredicateNotSatisfiedWithExtraInfo */ 1:
                            var extraInfo = predicateOutcome._0;
                            return wait(interval).then(function(param) {
                                loop(Caml_option.some(extraInfo));
                                return Promise.resolve(undefined);
                            });
                        case /* ErrorDuringPredicate */ 2:
                            resolve({
                                TAG: /* Error */ 1,
                                _0: {
                                    TAG: /* PredicateError */ 1,
                                    _0: predicateOutcome._0
                                }
                            });
                            return Promise.resolve(undefined);
                    }
                }).catch(function(predicateError) {
                    resolve({
                        TAG: /* Error */ 1,
                        _0: {
                            TAG: /* UncaughtPredicateError */ 0,
                            _0: predicateError
                        }
                    });
                    return Promise.resolve(undefined);
                });
            }
        };
        return loop(undefined);
    });
}
function nextTick(param) {
    return new Promise(function(resolve, param) {
        setTimeout(function(param) {
            return resolve(undefined);
        }, 0);
    });
}
function make(v1, v2, v3) {
    return [
        {
            TAG: /* Member1 */ 0,
            _0: v1
        },
        {
            TAG: /* Member2 */ 1,
            _0: v2
        },
        {
            TAG: /* Member3 */ 2,
            _0: v3
        }
    ];
}
function reduce(fn, accum, combo) {
    return List.fold_left(fn, accum, {
        hd: combo[0],
        tl: {
            hd: combo[1],
            tl: {
                hd: combo[2],
                tl: /* [] */ 0
            }
        }
    });
}
var Combo3 = {
    make: make,
    reduce: reduce
};
var Combo = {
    Combo3: Combo3
};
function pow(base, exponent) {
    return Math.pow(base, exponent) | 0;
}
var QueryString = {};
function t_encode$2(encoder_a, encoder_error, v) {
    if (typeof v !== "number") {
        if (v.TAG === /* Loaded */ 0) {
            return [
                "Loaded",
                Curry._1(encoder_a, v._0)
            ];
        } else {
            return [
                "LoadDidErr",
                Curry._1(encoder_error, v._0)
            ];
        }
    }
    switch(v){
        case /* HasNotRequested */ 0:
            return [
                "HasNotRequested"
            ];
        case /* Loading */ 1:
            return [
                "Loading"
            ];
        case /* CouldNotFind */ 2:
            return [
                "CouldNotFind"
            ];
    }
}
function t_decode$2(decoder_a, decoder_error, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "CouldNotFind":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* CouldNotFind */ 2
                    };
                }
            case "HasNotRequested":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* HasNotRequested */ 0
                    };
                }
            case "LoadDidErr":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Curry._1(decoder_error, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* LoadDidErr */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "Loaded":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Curry._1(decoder_a, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Loaded */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "Loading":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Loading */ 1
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function getLoadedValue(v) {
    if (typeof v === "number" || v.TAG !== /* Loaded */ 0) {
        return;
    } else {
        return Caml_option.some(v._0);
    }
}
function minify(minifyValue, v) {
    if (typeof v === "number" || v.TAG !== /* Loaded */ 0) {
        return v;
    } else {
        return {
            TAG: /* Loaded */ 0,
            _0: Curry._1(minifyValue, v._0)
        };
    }
}
function map(f, v) {
    if (typeof v === "number" || v.TAG !== /* Loaded */ 0) {
        return v;
    } else {
        return {
            TAG: /* Loaded */ 0,
            _0: Curry._1(f, v._0)
        };
    }
}
function stringify$1(stringifyValue, stringifyError, v) {
    if (typeof v !== "number") {
        if (v.TAG === /* Loaded */ 0) {
            return "Loaded(" + (Curry._1(stringifyValue, v._0) + ")");
        } else {
            return "LoadDidErr(" + (Curry._1(stringifyError, v._0) + ")");
        }
    }
    switch(v){
        case /* HasNotRequested */ 0:
            return "HasNotRequested";
        case /* Loading */ 1:
            return "Loading";
        case /* CouldNotFind */ 2:
            return "CouldNotFind";
    }
}
var Loadable = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    getLoadedValue: getLoadedValue,
    minify: minify,
    map: map,
    stringify: stringify$1
};
var $$Performance = {};
function t_encode$3(encoder_a, v) {
    if (v) {
        return [
            "NonDefault",
            Curry._1(encoder_a, v._0)
        ];
    } else {
        return [
            "Default"
        ];
    }
}
function t_decode$3(decoder_a, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Default":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Default */ 0
                    };
                }
            case "NonDefault":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Curry._1(decoder_a, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NonDefault */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function toOpt(v) {
    if (v) {
        return Caml_option.some(v._0);
    }
}
var HasDefault = {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    toOpt: toOpt
};
var hasSingleKey = function hasSingleKey(v, key) {
    var keys = Object.keys(v.raw);
    return keys.length === 1 && keys[0] === key;
};
var hasKeys = function hasKeys(v, keys) {
    return keys.every(function(key) {
        return !!v.raw[key];
    });
};
function isFloatWithin(lower, upper, n) {
    if (n >= lower) {
        return n <= upper;
    } else {
        return false;
    }
}
var isWebextensionPolyfillLoaded = function isWebextensionPolyfillLoaded() {
    return typeof browser != "undefined";
};
function waitForWebextensionPolyfillLoaded(param) {
    return waitForPromise2(5000, 500, function(param) {
        return Promise.resolve(Curry._1(isWebextensionPolyfillLoaded, undefined) ? {
            TAG: /* PredicateSatisfied */ 0,
            _0: undefined
        } : /* PredicateNotSatisfied */ 0);
    });
}
exports.Shortcut = Shortcut;
exports.Invalid_argument = Invalid_argument;
exports.noop_0 = noop_0;
exports.noop_1 = noop_1;
exports.spyTransform = spyTransform;
exports.spyPromise1 = spyPromise1;
exports.shortcut = shortcut;
exports.shortcut2 = shortcut2;
exports.shortcutWithIndex = shortcutWithIndex;
exports.shortcutWithIndex2 = shortcutWithIndex2;
exports.shortcutPromise = shortcutPromise;
exports.shortcutList = shortcutList;
exports.shortcutListWithIndex = shortcutListWithIndex;
exports.logAndRaiseJsError = logAndRaiseJsError;
exports.compose = compose;
exports.not_ = not_;
exports.Result = Result;
exports.GlobalTimeoutId = GlobalTimeoutId;
exports.GlobalIntervalId = GlobalIntervalId;
exports.WaitFor = WaitFor;
exports.wait = wait;
exports.waitFloat = waitFloat;
exports.waitForPromise = waitForPromise;
exports.waitFor = waitFor;
exports.WaitFor2 = WaitFor2;
exports.waitForPromise2 = waitForPromise2;
exports.nextTick = nextTick;
exports.Combo = Combo;
exports.pow = pow;
exports.QueryString = QueryString;
exports.Loadable = Loadable;
exports.$$Performance = $$Performance;
exports.HasDefault = HasDefault;
exports.hasSingleKey = hasSingleKey;
exports.hasKeys = hasKeys;
exports.isFloatWithin = isFloatWithin;
exports.isWebextensionPolyfillLoaded = isWebextensionPolyfillLoaded;
exports.waitForWebextensionPolyfillLoaded = waitForWebextensionPolyfillLoaded; /* Log-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 45083:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var Curry = __webpack_require__(41386);
var Belt_Array = __webpack_require__(2971);
var Debug__Utils$SmartcutsMacros = __webpack_require__(60936);
var Debug__Browser$SmartcutsMacros = __webpack_require__(52367);
function Env_groupEnd(prim) {
    console.groupEnd();
}
var instances = {
    contents: /* [] */ 0
};
var names = {
    contents: /* [] */ 0
};
var skips = {
    contents: /* [] */ 0
};
function isForceEnabled(namespace) {
    return namespace[namespace.length] === "*";
}
function isSkipped(namespace) {
    return List.exists(function(re) {
        return re.test(namespace);
    }, skips.contents);
}
function isEnabled(namespace) {
    if (isForceEnabled(namespace)) {
        return true;
    } else if (isSkipped(namespace)) {
        return false;
    } else {
        return List.exists(function(re) {
            return re.test(namespace);
        }, names.contents);
    }
}
function make(colorizeOpt, namespace) {
    var colorize = colorizeOpt !== undefined ? colorizeOpt : true;
    var timer = Debug__Utils$SmartcutsMacros.timer(undefined);
    var instance = {
        namespace: namespace,
        color: colorize ? /* Color */ ({
            _0: Debug__Utils$SmartcutsMacros.selectColor(Debug__Browser$SmartcutsMacros.colors, namespace)
        }) : /* NoColor */ 0,
        enabled: isEnabled(namespace)
    };
    instances.contents = {
        hd: instance,
        tl: instances.contents
    };
    var log = function log(log$1, message, args) {
        var delta = Debug__Utils$SmartcutsMacros.Format.ms(Curry._1(timer, undefined));
        var color = instance.color;
        if (color) {
            var formatted = Debug__Browser$SmartcutsMacros.format(namespace, delta, message);
            var color$1 = "color:" + color._0;
            return Curry._1(log$1, {
                hd: formatted,
                tl: {
                    hd: color$1,
                    tl: {
                        hd: "color: inherit",
                        tl: {
                            hd: color$1,
                            tl: args
                        }
                    }
                }
            });
        }
        var formatted$1 = "" + namespace + " " + message + " +" + delta;
        return Curry._1(log$1, {
            hd: formatted$1,
            tl: args
        });
    };
    var fnEnter = function fnEnter(message, args) {
        var delta = Debug__Utils$SmartcutsMacros.Format.ms(Curry._1(timer, undefined));
        var color = instance.color;
        if (color) {
            var formatted = Debug__Browser$SmartcutsMacros.format(namespace, delta, message);
            var color$1 = "color:" + color._0;
            return Debug__Browser$SmartcutsMacros.group({
                hd: formatted,
                tl: {
                    hd: color$1,
                    tl: {
                        hd: "color: inherit",
                        tl: {
                            hd: color$1,
                            tl: args
                        }
                    }
                }
            });
        }
        var formatted$1 = "" + namespace + " " + message + " +" + delta;
        return Debug__Browser$SmartcutsMacros.group({
            hd: formatted$1,
            tl: args
        });
    };
    var fnExit = function fnExit(ret) {
        log(Debug__Browser$SmartcutsMacros.log, "<-", {
            hd: ret,
            tl: /* [] */ 0
        });
        return Curry._1(Env_groupEnd, undefined);
    };
    var id = function id(prim) {
        return prim;
    };
    return {
        log1: function(m) {
            if (instance.enabled) {
                return log(Debug__Browser$SmartcutsMacros.log, m, /* [] */ 0);
            }
        },
        log2: function(m, a) {
            if (instance.enabled) {
                return log(Debug__Browser$SmartcutsMacros.log, m, {
                    hd: a,
                    tl: /* [] */ 0
                });
            }
        },
        log3: function(m, a, b) {
            if (instance.enabled) {
                return log(Debug__Browser$SmartcutsMacros.log, m, {
                    hd: a,
                    tl: {
                        hd: b,
                        tl: /* [] */ 0
                    }
                });
            }
        },
        log4: function(m, a, b, c) {
            if (instance.enabled) {
                return log(Debug__Browser$SmartcutsMacros.log, m, {
                    hd: a,
                    tl: {
                        hd: b,
                        tl: {
                            hd: c,
                            tl: /* [] */ 0
                        }
                    }
                });
            }
        },
        logMany: function(m, args) {
            if (instance.enabled) {
                return log(Debug__Browser$SmartcutsMacros.log, m, args);
            }
        },
        warn1: function(m) {
            if (instance.enabled) {
                return log(Debug__Browser$SmartcutsMacros.warn, m, /* [] */ 0);
            }
        },
        warn2: function(m, a) {
            if (instance.enabled) {
                return log(Debug__Browser$SmartcutsMacros.warn, m, {
                    hd: a,
                    tl: /* [] */ 0
                });
            }
        },
        warn3: function(m, a, b) {
            if (instance.enabled) {
                return log(Debug__Browser$SmartcutsMacros.warn, m, {
                    hd: a,
                    tl: {
                        hd: b,
                        tl: /* [] */ 0
                    }
                });
            }
        },
        warn4: function(m, a, b, c) {
            if (instance.enabled) {
                return log(Debug__Browser$SmartcutsMacros.warn, m, {
                    hd: a,
                    tl: {
                        hd: b,
                        tl: {
                            hd: c,
                            tl: /* [] */ 0
                        }
                    }
                });
            }
        },
        warnMany: function(m, args) {
            if (instance.enabled) {
                return log(Debug__Browser$SmartcutsMacros.warn, m, args);
            }
        },
        error1: function(m) {
            return log(Debug__Browser$SmartcutsMacros.error, m, /* [] */ 0);
        },
        error2: function(m, a) {
            return log(Debug__Browser$SmartcutsMacros.error, m, {
                hd: a,
                tl: /* [] */ 0
            });
        },
        error3: function(m, a, b) {
            return log(Debug__Browser$SmartcutsMacros.error, m, {
                hd: a,
                tl: {
                    hd: b,
                    tl: /* [] */ 0
                }
            });
        },
        error4: function(m, a, b, c) {
            return log(Debug__Browser$SmartcutsMacros.error, m, {
                hd: a,
                tl: {
                    hd: b,
                    tl: {
                        hd: c,
                        tl: /* [] */ 0
                    }
                }
            });
        },
        errorMany: function(m, args) {
            return log(Debug__Browser$SmartcutsMacros.error, m, args);
        },
        lazy1: function(f) {
            if (instance.enabled) {
                return log(Debug__Browser$SmartcutsMacros.log, Curry._1(f, undefined), /* [] */ 0);
            }
        },
        lazy2: function(f) {
            if (!instance.enabled) {
                return;
            }
            var match = Curry._1(f, undefined);
            return log(Debug__Browser$SmartcutsMacros.log, match[0], {
                hd: match[1],
                tl: /* [] */ 0
            });
        },
        lazy3: function(f) {
            if (!instance.enabled) {
                return;
            }
            var match = Curry._1(f, undefined);
            return log(Debug__Browser$SmartcutsMacros.log, match[0], {
                hd: match[1],
                tl: {
                    hd: match[2],
                    tl: /* [] */ 0
                }
            });
        },
        lazy4: function(f) {
            if (!instance.enabled) {
                return;
            }
            var match = Curry._1(f, undefined);
            return log(Debug__Browser$SmartcutsMacros.log, match[0], {
                hd: match[1],
                tl: {
                    hd: match[2],
                    tl: {
                        hd: match[3],
                        tl: /* [] */ 0
                    }
                }
            });
        },
        lazyMany: function(f) {
            if (!instance.enabled) {
                return;
            }
            var match = Curry._1(f, undefined);
            return log(Debug__Browser$SmartcutsMacros.log, match[0], match[1]);
        },
        fn1: function(m, pp1Opt, ppROpt, f, a) {
            var pp1 = pp1Opt !== undefined ? pp1Opt : id;
            var ppR = ppROpt !== undefined ? ppROpt : id;
            if (!instance.enabled) {
                return Curry._1(f, a);
            }
            fnEnter(m, {
                hd: Curry._1(pp1, a),
                tl: /* [] */ 0
            });
            var ret = Curry._1(f, a);
            fnExit(Curry._1(ppR, ret));
            return ret;
        },
        fn2: function(m, pp1Opt, pp2Opt, ppROpt, f, a, b) {
            var pp1 = pp1Opt !== undefined ? pp1Opt : id;
            var pp2 = pp2Opt !== undefined ? pp2Opt : id;
            var ppR = ppROpt !== undefined ? ppROpt : id;
            if (!instance.enabled) {
                return Curry._2(f, a, b);
            }
            fnEnter(m, {
                hd: Curry._1(pp1, a),
                tl: {
                    hd: Curry._1(pp2, b),
                    tl: /* [] */ 0
                }
            });
            var ret = Curry._2(f, a, b);
            fnExit(Curry._1(ppR, ret));
            return ret;
        },
        fn3: function(m, pp1Opt, pp2Opt, pp3Opt, ppROpt, f, a, b, c) {
            var pp1 = pp1Opt !== undefined ? pp1Opt : id;
            var pp2 = pp2Opt !== undefined ? pp2Opt : id;
            var pp3 = pp3Opt !== undefined ? pp3Opt : id;
            var ppR = ppROpt !== undefined ? ppROpt : id;
            if (!instance.enabled) {
                return Curry._3(f, a, b, c);
            }
            fnEnter(m, {
                hd: Curry._1(pp1, a),
                tl: {
                    hd: Curry._1(pp2, b),
                    tl: {
                        hd: Curry._1(pp3, c),
                        tl: /* [] */ 0
                    }
                }
            });
            var ret = Curry._3(f, a, b, c);
            fnExit(Curry._1(ppR, ret));
            return ret;
        },
        fn4: function(m, pp1Opt, pp2Opt, pp3Opt, pp4Opt, ppROpt, f, a, b, c, d) {
            var pp1 = pp1Opt !== undefined ? pp1Opt : id;
            var pp2 = pp2Opt !== undefined ? pp2Opt : id;
            var pp3 = pp3Opt !== undefined ? pp3Opt : id;
            var pp4 = pp4Opt !== undefined ? pp4Opt : id;
            var ppR = ppROpt !== undefined ? ppROpt : id;
            if (!instance.enabled) {
                return Curry._4(f, a, b, c, d);
            }
            fnEnter(m, {
                hd: Curry._1(pp1, a),
                tl: {
                    hd: Curry._1(pp2, b),
                    tl: {
                        hd: Curry._1(pp3, c),
                        tl: {
                            hd: Curry._1(pp4, d),
                            tl: /* [] */ 0
                        }
                    }
                }
            });
            var ret = Curry._4(f, a, b, c, d);
            fnExit(Curry._1(ppR, ret));
            return ret;
        },
        isEnabled: function(param) {
            return instance.enabled;
        },
        enable: function(param) {
            instance.enabled = true;
        }
    };
}
function resetNamespaces(param) {
    names.contents = /* [] */ 0;
    skips.contents = /* [] */ 0;
}
function parseFilter(filter1) {
    Belt_Array.keepMap(filter1.split(/[\s,]+/), function(x) {
        return x;
    }).filter(function(ns) {
        return ns !== "";
    }).forEach(function(namespace) {
        var namespace$1 = namespace.replace(/\*/g, ".*?");
        if (namespace$1[0] !== "-") {
            names.contents = {
                hd: new RegExp("^" + namespace$1 + "$"),
                tl: names.contents
            };
            return;
        }
        var namespace$2 = namespace$1.substr(1);
        skips.contents = {
            hd: new RegExp("^" + namespace$2 + "$"),
            tl: skips.contents
        };
    });
}
function enable(filter2) {
    Debug__Browser$SmartcutsMacros.save(filter2);
    resetNamespaces(undefined);
    parseFilter(filter2);
    return List.iter(function(i) {
        i.enabled = isEnabled(i.namespace);
    }, instances.contents);
}
function disable(param) {
    Debug__Browser$SmartcutsMacros.save(undefined);
    resetNamespaces(undefined);
    return List.iter(function(i) {
        i.enabled = false;
    }, instances.contents);
}
var filter = Debug__Browser$SmartcutsMacros.load(undefined);
if (filter !== undefined) {
    enable(filter);
}
exports.make = make;
exports.enable = enable;
exports.disable = disable;
exports.isEnabled = isEnabled; /* filter Not a pure module */ 


/***/ }),

/***/ 52367:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
function log(args) {
    return "object" === typeof console && console.log && Function.prototype.apply.call(console.log, console, args);
}
;
function warn(args) {
    return "object" === typeof console && console.warn && Function.prototype.apply.call(console.warn, console, args);
}
;
function error(args) {
    return "object" === typeof console && console.error && Function.prototype.apply.call(console.error, console, args);
}
;
function log$1(args) {
    log($$Array.of_list(args));
}
function warn$1(args) {
    warn($$Array.of_list(args));
}
function error$1(args) {
    error($$Array.of_list(args));
}
var colors = [
    "#0000CC",
    "#0000FF",
    "#0033CC",
    "#0033FF",
    "#0066CC",
    "#0066FF",
    "#0099CC",
    "#0099FF",
    "#00CC00",
    "#00CC33",
    "#00CC66",
    "#00CC99",
    "#00CCCC",
    "#00CCFF",
    "#3300CC",
    "#3300FF",
    "#3333CC",
    "#3333FF",
    "#3366CC",
    "#3366FF",
    "#3399CC",
    "#3399FF",
    "#33CC00",
    "#33CC33",
    "#33CC66",
    "#33CC99",
    "#33CCCC",
    "#33CCFF",
    "#6600CC",
    "#6600FF",
    "#6633CC",
    "#6633FF",
    "#66CC00",
    "#66CC33",
    "#9900CC",
    "#9900FF",
    "#9933CC",
    "#9933FF",
    "#99CC00",
    "#99CC33",
    "#CC0000",
    "#CC0033",
    "#CC0066",
    "#CC0099",
    "#CC00CC",
    "#CC00FF",
    "#CC3300",
    "#CC3333",
    "#CC3366",
    "#CC3399",
    "#CC33CC",
    "#CC33FF",
    "#CC6600",
    "#CC6633",
    "#CC9900",
    "#CC9933",
    "#CCCC00",
    "#CCCC33",
    "#FF0000",
    "#FF0033",
    "#FF0066",
    "#FF0099",
    "#FF00CC",
    "#FF00FF",
    "#FF3300",
    "#FF3333",
    "#FF3366",
    "#FF3399",
    "#FF33CC",
    "#FF33FF",
    "#FF6600",
    "#FF6633",
    "#FF9900",
    "#FF9933",
    "#FFCC00",
    "#FFCC33"
];
function format(namespace, diff, payload) {
    return "%c" + namespace + " %c" + payload + "%c +" + diff;
}
function group(args) {
    return "object" === typeof console && console.group && Function.prototype.apply.call(console.group, console, args);
}
;
function group$1(args) {
    group($$Array.of_list(args));
}
function save(param) {}
function load(param) {
    return "";
}
exports.log = log$1;
exports.warn = warn$1;
exports.error = error$1;
exports.colors = colors;
exports.format = format;
exports.group = group$1;
exports.save = save;
exports.load = load; /*  Not a pure module */ 


/***/ }),

/***/ 60936:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$String = __webpack_require__(65760);
var Caml_array = __webpack_require__(11748);
var Caml_int32 = __webpack_require__(48723);
var _m = 1000 * 60;
var _h = _m * 60;
var _d = _h * 24;
function _format(t, d, unit) {
    var s = String(Math.round(t / d));
    return "" + s + " " + unit;
}
function ms(v) {
    if (v >= _d) {
        return _format(v, _d, "d");
    } else if (v >= _h || v >= _m) {
        return _format(v, _h, "h");
    } else if (v >= 1000) {
        return _format(v, 1000, "s");
    } else {
        return _format(v, 1, "ms");
    }
}
var Format = {
    _s: 1000,
    _m: _m,
    _h: _h,
    _d: _d,
    _format: _format,
    ms: ms
};
function hash(input) {
    var value = {
        contents: 0
    };
    $$String.iter(function(c) {
        value.contents = ((value.contents << 5) - value.contents | 0) + c | 0;
    }, input);
    return Math.abs(value.contents);
}
function selectColor(colors, string) {
    var choices = colors.length;
    var index = Caml_int32.mod_(hash(string), choices);
    return Caml_array.get(colors, index);
}
function timer(param) {
    var prev = {
        contents: Date.now()
    };
    return function(param) {
        var now = Date.now();
        var delta = now - prev.contents;
        prev.contents = now;
        return delta;
    };
}
exports.Format = Format;
exports.hash = hash;
exports.selectColor = selectColor;
exports.timer = timer; /* No side effect */ 


/***/ })

}]);